import type { FunctionComponent } from 'react';

import { useGlobalSearchTableParams } from '../../../global-search/use-global-search-table-params';
import { EmployeeRelatedSkillsTable } from './EmployeesRelatedSkillsTable';
import { EmployeeSearchTermTable } from './EmployeesSearchTermTable';

export const EmployeesTable: FunctionComponent = () => {
    const { isValidSearchTerm, isValidSkillIdsList, searchTermResult, skillIds } = useGlobalSearchTableParams();

    if (isValidSearchTerm) {
        return <EmployeeSearchTermTable searchTerm={searchTermResult} />;
    }

    if (isValidSkillIdsList) {
        return <EmployeeRelatedSkillsTable skillIds={skillIds} />;
    }

    return null;
};
